import React, {Component} from "react";
import {
  Container,
  Card,
  CardHeader,
  Row,
  Col,
  CardBody,
  DatePicker,
  FormSelect,
  FormInput,
  Button,
  Form,
} from "shards-react";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { FiSearch } from "react-icons/fi";
// import Select from "react-select";
import moment from "moment";
import {actions as AppActions} from "../../_stores/app.store";
import Modal from "react-bootstrap/Modal";
import BatchReportService from "../../services/batchReport.service";
import SupplierService from "../../services/supplier.service";
import ProcessLogService from "../../services/processLog.service";
import ProcessFileService from "../../services/processFile.service";
import QueuingService from "../../services/queuing.service";
import ProcessLogs from "./ProcessLogs";
import ReportTable from "./ReportTable";
import { TiDeleteOutline } from "react-icons/ti";
  import TableRow from '../layout/TableRow';
import TableColumnRow from '../layout/TableColumnRow';
import { FcPlus, FcAlphabeticalSortingAz, FcAlphabeticalSortingZa } from "react-icons/fc";
import refresh from "../../images/refresh.png";
import ScaleLoader from "react-spinners/ScaleLoader";
import projectService from "../../services/project.service";
import ReportService from "../../services/report.service";
import ConversionDataService from "../../services/conversions.service";
import * as XLSX from "xlsx";
import { ToastContainer, toast } from "react-toastify";
import { sub } from "date-fns";
import { batch } from "react-redux";
//import logger from 'logging-library';
//import { CustomErrorComponent } from 'custom-error';
import incrementalService from "../../services/incremental.service";

const INDIA = process.env.REACT_APP_MARKET === "INDIA";
const SPAIN = process.env.REACT_APP_MARKET === "SPAIN";
const SAUDI = process.env.REACT_APP_MARKET === "SAUDI";
const EGYPT = process.env.REACT_APP_MARKET === "EGYPT";
let processFileByIdQueueArray = [];

const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

const date = new Date();
const currentyear = date.getUTCFullYear();
let YEAR = [];
YEAR.push(currentyear-3);
YEAR.push(currentyear-2);
YEAR.push(currentyear-1);
YEAR.push(currentyear);
YEAR.push(currentyear+1);
YEAR.push(currentyear+2);

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#004A7C",
};

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const currentDate = new Date();
const currentMonth = MONTHS[currentDate.getMonth() - 1];

const Columns = [
  {
    title: "Batch ID",
    value: "_id",
  },
  // {
  //   title: "Download Time",
  //   value: "downloadTimeStamp",
  // },
  {
    title: "File Name",
    value: "fileName",
  },
  {
    title: "File Metadata",
    value: "fileMetadata",
  },
  {
    title: "File Type",
    value: "fileType",
  },
  {
    title: "Step",
    value: "step",
  },
  {
    title: "Supplier Code",
    value: "supplierCode",
  },
  // {
  //   title: "Time Log",
  //   value: "Batch Id",
  // },
  // {
  //   title: "Updated At",
  //   value: "updatedAt",
  // },
  {
    title: "Year - Month",
    value: "yearmonth",
  }
];


class ViewBatchReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: "validation",
      batchReport: [],
      filteredBReport: [],
      downloadedReport: [],
      processReport:[],
      validationReport: [],
      completeReport: [],
      conversionReport: [],
      conversionCompleteReport: [],
      pendingReport: [],
      failedReport: [],
      uploadedReport: [],
      cancelledReport: [],
      selectedBatch: {},
      batchLogs: [],
      dateFrom: null,
      dateTo: null,
      supplierList: [],
      selectedSupplier: "",
      projectList: [],
      yearList: YEAR,
      monthList: MONTHS,
      selectedMonth: currentMonth,
      selectedProject: "",
      fullscreen: false,
      showModal: false,
      showModalProcessed: false,
      rows:[],
      columnsRows:"",
      headers:[],
      originalData:[],
      sortedColumn: "",
      filteredColumn: "",
      filteredColumnValue: "",
      batchIdArray: [],
      sortType: true,
      processFileByIdQueue: [],
      conversionsList: [],
      uploadReady: false,
      uploadIncrementalRecords: false,
      batchData: [],
      selectedYear: currentyear,
      uploadedFileType: "",
      displayError: false
    };
    this.fetchBatchReport = this.fetchBatchReport.bind(this);
    this.tabSelected = this.tabSelected.bind(this);
    this.batchSelected = this.batchSelected.bind(this);
    this.dateChanged = this.dateChanged.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.processFile = this.processFile.bind(this);
    this.cancelProcessFile = this.cancelProcessFile.bind(this);
    this.batchIdClicked = this.batchIdClicked.bind(this);
    this.processFileById = this.processFileById.bind(this);
    this.viewRawFileById = this.viewRawFileById.bind(this);
    this.viewOriginalFileById = this.viewOriginalFileById.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.hideModal = this.hideModal.bind(this)
    this.hideModalProcessed = this.hideModalProcessed.bind(this)
    this.uploadFiles = this.uploadFiles.bind(this);
    this.uploadFileById = this.uploadFileById.bind(this);
    this.processSASFileById = this.processSASFileById.bind(this);
    this.fetchBatchByDates = this.fetchBatchByDates.bind(this);
    this.onChangeSupplierNameTxt = this.onChangeSupplierNameTxt.bind(this);
    this.onChangeSupplierCodeTxt = this.onChangeSupplierCodeTxt.bind(this);
    this.onChangeFilteredColumnValue = this.onChangeFilteredColumnValue.bind(this);
    this.checkboxChecked = this.checkboxChecked.bind(this);
    this.processMultipleFile = this.processMultipleFile.bind(this);
    this.uploadMultipleFile = this.uploadMultipleFile.bind(this);
    this.sortingAlphabet = this.sortingAlphabet.bind(this);
    this.exportConversionsToExcel = this.exportConversionsToExcel.bind(this);
    this.prepWorkbookFromJson = this.prepWorkbookFromJson.bind(this);
    this.createUrlFromBlob = this.createUrlFromBlob.bind(this);
    this.getTableData = this.getTableData.bind(this);
    this.downloadConversionFile = this.downloadConversionFile.bind(this);
    this.uploadConversionFile = this.uploadConversionFile.bind(this);
    this.downloadFileById = this.downloadFileById.bind(this);
    this.downloadIncrementalFile = this.downloadIncrementalFile.bind(this);
    this.uploadIncrementalFile = this.uploadIncrementalFile.bind(this);

    this.onFileChanged = this.onFileChanged.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleFileChanged = this.handleFileChanged.bind(this);
    this.handleBulkUpload = this.handleBulkUpload.bind(this);
    this.downloadMultipleFile = this.downloadMultipleFile.bind(this);
    this.exportMultipleFileToCSV = this.exportMultipleFileToCSV.bind(this);
    this.handleSelectedSupplierChange = this.handleSelectedSupplierChange.bind(this);
    this.handleIncrementalData = this.handleIncrementalData.bind(this);
    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    this.fetchBatchReport();
    this.fetchSuppliers();
   // this.fetchProjects();
  }

  componentDidUpdate(prevProps) {}

  fetchBatchReport() {
    AppActions.setLoading(true);
    BatchReportService.getByProject(this.props.projectId).then((response) => {
      AppActions.setLoading(false);
      if (response.data && response.data.data && response.data.data.length > 0) {

          let results = response.data.data;
          const batchReport = results.map(batch => {
            return {
              yearmonth: `${batch.year}-${batch.month}`,
              ...batch
            }
          });

          this.setState({
            batchReport: batchReport,
            filteredBReport: batchReport,
            //pendingReport: response.data.data
          });
          this.categoriseBatchReport(batchReport);
      }
    });
  }

  categoriseBatchReport(repoData) {
    if(repoData){
    const downloadedReport = [],
      validationReport = [],
      processReport = [],
      completeReport = [],
      conversionReport = [],
      conversionCompleteReport = [],
      failedReport = [],
      pendingReport = [],
      uploadedReport = [],
      cancelledReport = [];
    for (let i = 0; i < repoData.length; i++) {
      const repoitem = repoData[i];
      // if(repoitem.supplierCode === '207768'){
      //   console.log("repoitem", repoitem);
      // }
      const d = new Date();
      const currentyear = d.getUTCFullYear();
      const currentMonth = MONTHS[d.getMonth() - 1]; 

      if(SPAIN){
        if((repoitem.month !== currentMonth || repoitem.year !== currentyear) && repoitem.step !== "complete"){
          pendingReport.push(repoitem);
        }
      } else if(SPAIN){
        if((repoitem.month !== currentMonth || repoitem.year !== currentyear) && repoitem.step !== "complete"){
          pendingReport.push(repoitem);
        }
      } else {
        if((repoitem.month !== currentMonth || repoitem.year !== currentyear) && repoitem.step !== "uploaded"){
          pendingReport.push(repoitem);
        }
      }

      switch (repoitem.step) {
        case "downloaded":
          if(INDIA && (repoitem.month == currentMonth && repoitem.year == currentyear) && repoitem.step == "downloaded"){
            downloadedReport.push(repoitem);
          } else {
            downloadedReport.push(repoitem);
          }
          break;
        case "pending":
          pendingReport.push(repoitem);
          break;
        case "validation":
        case "Validation":
        case "File Process":
          validationReport.push(repoitem);
          // if((repoitem.month == currentMonth && repoitem.year == currentyear)){
          //   validationReport.push(repoitem);
          // }
          break;
        // case "File Process":
        //   processReport.push(repoitem);
        //   break;  
        case "process":
        case "complete":
        case "cancelled":
          completeReport.push(repoitem);
          break;
        case "conversion":
          conversionReport.push(repoitem);
          break;
        case "conversion_added":
          conversionCompleteReport.push(repoitem);
          break;
        case "failed":
          failedReport.push(repoitem);
        break;
        case "uploaded":
          uploadedReport.push(repoitem);
          break;
        // case "cancelled":
        //   cancelledReport.push(repoitem);
        //   break;
        default:
          console.info("Default case in categorise report!");
      }
    }
    this.setState(
      {
        downloadedReport,
        validationReport,
        processReport,
        completeReport,
        conversionReport,
        conversionCompleteReport,
        failedReport,
        pendingReport,
        uploadedReport,
        cancelledReport
      },
      this.resetLogByActiveTab
    );
    }
    else{
      alert("no data found");
    }
  }

  fetchLogsByBatch(batchid) {
    AppActions.setLoading(true);
    ProcessLogService.getByBatch(batchid).then((response) => {
      AppActions.setLoading(false);
      const batch_logs =
        response.data && response.data.data && response.data.data.length
          ? response.data.data
          : [];
      this.setState({
        batchLogs: batch_logs,
      });
    });
  }

  async handleSelectedSupplierChange(evt) {
    console.log(`handleChange Option selected:`, evt.target.value);
    this.setState({
      selectedSupplier: evt.target.value === "0" ? "" : evt.target.value,
    })
  }

  onChangeSupplierNameTxt(e){
    var str= e.target.value.toLowerCase();
    var filteredData = this.state.batchReport;
    if(str.length >= 3){
        var selectedList = this.state.supplierList;
        var supplier=[];
        var searchedSuppliers=[];
        /*listing all supplier code from name typed */
        selectedList.filter(function(data) {
          if(data.supplierName.toString().toLowerCase().includes(str)){
            searchedSuppliers.push(data.supplierCode);
            return true
          }
        });
      /* Removing Duplicates */
      const uniqueSuppliers = Array.from(new Set(searchedSuppliers));

      /* Finding actual data for searched suppliers */
      uniqueSuppliers.map(function(data){
        filteredData.filter(function(dataList) {
          if(dataList.supplierCode.toString().toLowerCase().includes(data)){
            supplier.push(dataList)
              }
            });
        });

    
      this.setState({
        filteredBReport:supplier
      }) 
      this.categoriseBatchReport(supplier);
    }
    else{
      this.setState({
        filteredBReport:filteredData
      }) 
      this.categoriseBatchReport(filteredData);
    }
  
  }


  onChangeSupplierCodeTxt(e){
    var str= e.target.value.toLowerCase();
    var filteredData = this.state.batchReport;
    var supplier = filteredData.filter(function(data) {
      if(data.supplierCode.toString().toLowerCase().includes(str)){
        return true
      }else{
        
      }
    });
    this.setState({
      filteredBReport:supplier
    })

    this.categoriseBatchReport(supplier);
  }

  fetchBatchByDates() {
    const { dateFrom, dateTo } = this.state;
    AppActions.setLoading(true);
    BatchReportService.getBatchByDates(dateFrom,dateTo).then((response) => {
      AppActions.setLoading(false);
      if (response.data && response.data.data && response.data.data.length > 0) {
        this.setState({
          batchReport: response.data.data,
          filteredBReport: response.data.data,
          //pendingReport: response.data.data
        });
        this.categoriseBatchReport(response.data.data);
      }
    });

  }

  fetchSuppliers() {
    AppActions.setLoading(true);
    SupplierService.getByProject(this.props.projectId).then((response) => {
      AppActions.setLoading(false);
      if (response.data && response.data.data && response.data.data.length) {
        const supplierArray = response.data.data;
        
        this.setState({
          supplierList: supplierArray,
        });
      }
    });
  }

  tabSelected(tabKey) {
    this.resetLastActiveTab();

    this.setState({ selectedTab: tabKey, batchIdArray: [], batchData: [] }, this.resetLogByActiveTab);
  }

  resetLogByActiveTab() {
    const {
      selectedTab,
      filteredBReport,
      downloadedReport,
      validationReport,
      processReport,
      completeReport,
      conversionReport,
      conversionCompleteReport,
      failedReport,
      pendingReport,
      uploadedReport,
      cancelledReport
    } = this.state;
    const reportlist =
      selectedTab === "downloaded"
        ? downloadedReport
        : selectedTab === "validation"
        ? validationReport
        // : selectedTab === "File Process"
        // ? processReport
        : selectedTab === "complete"
        ? completeReport
        : selectedTab === "conversion"
        ? conversionReport
        : selectedTab === "conversion_added"
        ? conversionCompleteReport
        : selectedTab === "failed"
        ? failedReport
        : selectedTab === "uploaded"
        ? uploadedReport
        : selectedTab === "pending"
        ? pendingReport
        // ? selectedTab === "cancelled"
        // : cancelledReport
        : filteredBReport;
        
    if (reportlist.length) this.batchSelected(reportlist[0]);
    else this.setState({ selectedBatch: {} });
  }

  resetLastActiveTab() {
    const {
      selectedTab,
      filteredBReport,
      downloadedReport,
      validationReport,
      completeReport,
      conversionReport,
      conversionCompleteReport,
      failedReport,
      pendingReport,
      uploadedReport,
    } = this.state;
    let selectedLastReport = filteredBReport;
    const reportlist =
      selectedTab === "downloaded"
        ? selectedLastReport = downloadedReport
        : selectedTab === "validation"
        ? selectedLastReport = validationReport
        : selectedTab === "complete"
        ? selectedLastReport = completeReport
        : selectedTab === "conversion"
        ? selectedLastReport = conversionReport
        : selectedTab === "conversion_added"
        ? selectedLastReport = conversionCompleteReport
        : selectedTab === "failed"
        ? selectedLastReport = failedReport
        : selectedTab === "uploaded"
        ? selectedLastReport = uploadedReport
        : selectedTab === "pending"
        ? selectedLastReport = pendingReport
        : filteredBReport;

    selectedLastReport.map(item => {
      delete item.checked;
      return item;
    });
        
    if (reportlist.length) this.batchSelected(selectedLastReport);
    else this.setState({ selectedBatch: {} });
  }

  batchSelected(batch) {
    this.fetchLogsByBatch(batch._id);
    this.setState({ selectedBatch: batch });
  }

  dateChanged(dVal, dKey) {
    this.setState({ [dKey]: dVal });
  }
  async sortingAlphabet (evt) {
    const { sortType, sortedColumn } = this.state;
    this.setState({ sortType: !sortType }, function() {
      if(sortedColumn && (sortedColumn !== 0 || sortedColumn !== '0')){
        this.startSorting(sortedColumn);
      }
    });
    
    
  }

  async startSorting (evt) {
    let selectedValue = (evt.target && evt.target.value) || evt;
    this.setState({ sortedColumn: selectedValue});
    const { batchReport, sortType } = this.state;
    let filteredlist = batchReport;
    if(selectedValue === 'yearmonth'){
      filteredlist = filteredlist.sort(function(a, b){
        return YEAR.indexOf(a['year']) - YEAR.indexOf(b['year']);
      });
      filteredlist = filteredlist.sort(function(a, b){
        return MONTHS.indexOf(a['month']) - MONTHS.indexOf(b['month']);
      });
      if(!sortType){ filteredlist.reverse(); }
      
    } else {
      filteredlist = this.sortByKey(batchReport, { prop: selectedValue, desc: !sortType });
    }
    this.setState({ filteredBReport: filteredlist, selectedBatch: {} });
    this.categoriseBatchReport(filteredlist);
  }

  sortByKey = (function () {
    var toString = Object.prototype.toString,
        // default parser function
        parse = function (x) { return x; },
        // gets the item to be sorted
        getItem = function (x) {
          var isObject = x != null && typeof x === "object";
          var isProp = isObject && this.prop in x;
          return this.parser(isProp ? x[this.prop] : x);
        };
        
    /**
     * Sorts an array of elements.
     *
     * @param  {Array} array: the collection to sort
     * @param  {Object} cfg: the configuration options
     * @property {String}   cfg.prop: property name (if it is an Array of objects)
     * @property {Boolean}  cfg.desc: determines whether the sort is descending
     * @property {Function} cfg.parser: function to parse the items to expected type
     * @return {Array}
     */
    return function sortby (array, cfg) {
      if (!(array instanceof Array && array.length)) return [];
      if (toString.call(cfg) !== "[object Object]") cfg = {};
      if (typeof cfg.parser !== "function") cfg.parser = parse;
      cfg.desc = !!cfg.desc ? -1 : 1;
      return array.sort(function (a, b) {
        a = getItem.call(cfg, a);
        b = getItem.call(cfg, b);
        return cfg.desc * (a < b ? -1 : +(a > b));
      });
    };
    
  }());

  applyFilter(selectedValue) {
    const { filteredColumn } = this.state;
    let filteredlist = this.state.batchReport;
    if(filteredColumn){
      filteredlist = selectedValue
      ? filteredlist.filter((itm) => itm[filteredColumn] && itm[filteredColumn].toLowerCase().includes(selectedValue.toLowerCase()))
      : filteredlist;

      this.setState({ filteredBReport: filteredlist, selectedBatch: {} });
      this.categoriseBatchReport(filteredlist);
    }
    
  }
  

  onChangeFilteredColumnValue(e){
    const filteredColumnValue = e.target.value;
    const { filteredColumn } = this.state;
    this.setState({ filteredColumnValue: filteredColumnValue});
    if(filteredColumn){
      this.applyFilter(filteredColumnValue);
    }
  }

  filterByDateRange(dataIn) {
    const { dateFrom, dateTo } = this.state;
    const formDate = moment(dateFrom);
    const toDate = moment(dateTo);
    return dataIn.filter((itm) => {
      return (
        formDate.isSameOrBefore(itm.downloadTimeStamp, "day") &&
        toDate.isSameOrAfter(itm.downloadTimeStamp, "day")
      );
    });
  }

  filterBySupplier(batchreport, selectedValue) {
    return selectedValue
      ? batchreport.filter((itm) => itm.supplierCode.includes(selectedValue))
      : batchreport;
  }

  filterById(selectedValue) {
    let filteredlist = this.state.batchReport;
    return filteredlist.filter((item) => item._id === selectedValue);
  }

  downloadFile() {
    const payload = { selectedSupplier: this.state.selectedSupplier, year: this.state.selectedYear, month: this.state.selectedMonth, projectId: this.props.projectId};
    console.log('downloadFile.payload', payload);
    ProcessFileService.download(payload).then((response) => {
    });
  }

  cancelProcessFile(id) {
    ProcessFileService.cancelFileById(id).then((response) => {
    });
  }

  batchIdClicked(id) {
    // ProcessFileService.cancelFileById(id).then((response) => {
    // });
  }

  processFile() {
    const payload = { year: this.state.selectedYear, month: this.state.selectedMonth, projectId: this.props.projectId };
    ProcessFileService.process(payload).then((response) => {
    });
  }

  processFileById(id, supplierCode) {
    // let processFileByIdQueueArray = [...this.state.processFileByIdQueue];
    // if(processFileByIdQueueArray.indexOf(supplierCode) == -1) processFileByIdQueueArray.push(supplierCode);
    // this.setState({processFileByIdQueue: processFileByIdQueueArray});

    if(processFileByIdQueueArray.indexOf(supplierCode) == -1) processFileByIdQueueArray.push(supplierCode);
    setTimeout(() => {
      if(processFileByIdQueueArray.indexOf(supplierCode) > -1) processFileByIdQueueArray.shift(supplierCode);
    }, 1000*120);
    console.log('processFileByIdQueueArray', processFileByIdQueueArray);
    ProcessFileService.processById(id).then((response) => {
    });
  }

  uploadFiles() {
    const payload = { year: this.state.selectedYear, month: this.state.selectedMonth, projectId: this.props.projectId };
    ProcessFileService.uploadFiles(payload).then((response) => {
    });
  }

  uploadFileById(id) {
    ProcessFileService.uploadFileById(id).then((response) => {
    });
  }

  uploadFileToDB(id) {
    ProcessFileService.uploadFileToDB(id).then((response) => {
    });
  }

  processSASFileById(id) {
    ProcessFileService.processSASFileById(id).then((response) => {
    });
  }

  viewRawFileById(id) {
    this.setState({
      showModalProcessed: true,
      fullscreen: true,
    })
    ProcessFileService.viewRawById(id).then((response) => {
      
      if(response.data.output) {
        this.setState({ 
          rows: response.data.output, 
          loading: false
        })
      }
    });
  
  }

  viewOriginalFileById(id) {
    this.setState({
      fullscreen: true,
      showModal: true,
    });

    ProcessFileService.viewOriginalFileById(id).then((response) => {
      this.setState({
        originalData: response.data.output
      });

    });
  }

  hideModal() {
    this.setState({
      showModal: false, 
    });
  }

  hideModalProcessed() {
    this.setState({
      showModalProcessed: false, 
    });
  }

  checkboxChecked(reportData) {
    let batchIdArray = reportData.filter(x => x.checked === true).map(x => x._id);
    //let batchData = reportData.filter(x => x.checked === true).map(x => `${x._id}-${x.year}${MONTHS.indexOf(x.month) + 1 < 10 ? `0${MONTHS.indexOf(x.month) + 1}` : MONTHS.indexOf(x.month) + 1}`);

    let batchData = reportData.filter(x => x.checked === true).map(x => `${x._id}-${x.year.slice(-2)}${MONTHS.indexOf(x.month) + 1 < 10 ? `0${MONTHS.indexOf(x.month) + 1}` : MONTHS.indexOf(x.month) + 1}`);
    console.log('batchData', batchData);
    this.setState({
      batchIdArray: batchIdArray, 
      batchData: batchData
    });
  }

  processMultipleFile() {
    const { batchIdArray } = this.state;
    const payload = { projectId: this.props.projectId, batchIdArray: batchIdArray };
    ProcessFileService.processMultipleFile(payload).then((response) => {
    });
  }

  uploadMultipleFile() {
    const { batchIdArray } = this.state;
    const payload = { projectId: this.props.projectId, batchIdArray: batchIdArray };
    ProcessFileService.uploadMultipleFile(payload).then((response) => {
    });
  }

  deleteFileById(id) {
    ProcessFileService.deleteFileById(id).then((response) => {
    });
  }

  downloadMultipleFile() {
    const { batchIdArray } = this.state;
    console.log('downloadMultipleFile.batchIdArray', batchIdArray);
    this.getTableData({}, batchIdArray);
  }

  downloadConversionFile(id, item) {
    console.log('downloadConversionFile.id', id);
    console.log('downloadConversionFile.item', item);
    this.getTableData(item, [id]);
  }

  uploadConversionFile() {
    this.setState({ uploadReady: true });
  }

  goToReport = (itemId, item) => {
    // console.log('goToReport.clicked', item);
    // console.log('goToReport.this.props', this.props);
    const projectId = item.projectId;
    const supplierCode = item.supplierCode;
    this.props.viewprops.history.push(`/report/${projectId}/supplier/${supplierCode}`);
  }

  addToQueue = (itemId, item) => {
    console.log('addToQueue.clicked', item);
    const projectId = item.projectId;
    const supplierCode = item.supplierCode;
    const payload = { projectId: this.props.projectId, batchId: itemId, supplierCode: supplierCode };
    QueuingService.addToQueue(payload).then((response) => {
    });
  }
  downloadFileById(id,month,year) {
    const batch = `${id}-${year.slice(-2)}${MONTHS.indexOf(month) + 1 < 10 ? `0${MONTHS.indexOf(month) + 1}` : MONTHS.indexOf(month) + 1}`;
    console.log('downloadFileById.batchData', batch);
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    window.open(`${BASE_URL}/download/transactionmaster/${batch}`, '_blank');
  }

  exportMultipleFileToCSV() { 
    const { batchData } = this.state;
    console.log('exportMultipleFileToCSV.batchData', batchData.join(','));
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    window.open(`${BASE_URL}/download/transactionmaster/${batchData.join(',')}`, '_blank');
  }

  downloadRawFile(id, item) {
    const batch = `${id}`;
    console.log('downloadFileById.batchData', batch);
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    window.open(`${BASE_URL}/download/rawfile/${batch}`, '_blank');
  }

  downloadErrorFile(id, item) {
    const batch = `${id}`;
    console.log('downloadErrorFile.batchData', batch);
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    window.open(`${BASE_URL}/download/errorfile/${batch}`, '_blank');
  }

  getTableData(item, batchIdArray) {
    AppActions.setLoading(true);
    console.log('getTableData', item);

    const queryObj = {
      projectId: this.props.projectId,
      supplierCode: item && item.supplierCode,
      batchIdArray: batchIdArray || [],
      isConversionFound: false
    };

    console.log('getTableData.queryObj', queryObj);
    ReportService.getTableData(queryObj).then((response) => {
      AppActions.setLoading(false);
      if (response.data && response.data.data && response.data.data.length > 0) {
        const { supplierList } = this.state;
        //console.log("filteredSuppliers.supplierList", supplierList);
        const conversionsListArray = JSON.parse(JSON.stringify(response.data.data));
        //console.log("filteredSuppliers.conversionsListArray", conversionsListArray);
        const supplier = supplierList.filter((item) => item.supplierCode === conversionsListArray[0].supplierCode);
        //console.log("filteredSuppliers.supplier", supplier);

        const conversionsList = conversionsListArray.map(v => ({...v, erpName: supplier[0].supplierERP }));

        this.setState({ conversionsList: conversionsList}, () => {
          this.exportConversionsToExcel();
        });
      }
    });
  }

  exportConversionsToExcel(type) {
    const { conversionsList } = this.state;
    const sheetdata = [];
    sheetdata.push(["Batch Id", "Retailer ID", "ERP Name", "Company Name", "Product Code", "Product Name", "UOM", "Conversion", "Opening Stk", "Receipt", "Sales Qty", "Closing Stk", "PURCHASE RATE", "MRP", "Conversion Found", "Unique Key" ]);
    for (let i = 0; i < conversionsList.length; i++) {
      const conItem = conversionsList[i];
      sheetdata.push([conItem.batchId, conItem.supplierCode, conItem.erpName, conItem.COMPANY_NAME, conItem.PROD_CODE, conItem.PRODUCT_NAME, conItem.UOM, conItem.Conversion, conItem.OPENING_STOCK, conItem.GOODS_RECEIVED, conItem.SALES_QTY, conItem.CLOSING_STOCK, conItem.PUR_RATE, conItem.MRP, conItem.isConversionFound, conItem.uniquekey]);
    }
    var fileName = "conversion_factor_master_" + new Date().getTime() + EXCEL_EXTENSION;
    this.prepWorkbookFromJson(sheetdata, fileName);
  }

  prepWorkbookFromJson(sheetdata, filename) {
    const worksheet = XLSX.utils.json_to_sheet(sheetdata, {
      skipHeader: true,
    });
    const wsColWidths = sheetdata[0].map((th) => ({ wch: th.length + 1 }));
    worksheet["!cols"] = wsColWidths;
    const workbook = {
      Sheets: { ["Sheet1"]: worksheet },
      SheetNames: ["Sheet1"],
    };
    const excelBuffer = XLSX.write(workbook, {
      type: "buffer",
      bookType: "xlsx",
    });
    this.createUrlFromBlob(excelBuffer, filename);
  }

  createUrlFromBlob(bufferData, filename) {
    const blob = new Blob([bufferData], { type: EXCEL_TYPE });
    const objurl = URL.createObjectURL(blob);
    this.downloadFileObj(objurl, filename);
    URL.revokeObjectURL(objurl);
  }

  downloadFileObj(objurl, filename) {
    const anchor = document.createElement("a");
    anchor.href = objurl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  onFileChanged(evt) {
    AppActions.setLoading(true);
    const { target } = evt;
    let file = null;

    if (target.files && target.files.length) {
      file = target.files[0];
    }
    this.readFileData(file);
  }

  async readFileData(file) {
    const reader = new FileReader();
    if (reader.readAsBinaryString) {
      reader.onload = async (e) => {
        this.extractExcelData(reader.result);
      };
      reader.readAsBinaryString(file);
    }
  }

  extractExcelData(data) {
    const workbook = XLSX.read(data, {
      type: "binary",
    });
    const sheet01 = workbook.Sheets[workbook.SheetNames[0]];
    const sheetdata = XLSX.utils.sheet_to_json(sheet01, {
      header: 1,
    });
    console.log('extractExcelData.sheetdata', sheetdata);
    sheetdata.splice(0, 1);
    if (sheetdata.length && sheetdata[0].length)
      this.setState({
        excelRows: sheetdata,
        uploadReady: true,
      });
    else this.notify("error", "No data found in the sheet");
    AppActions.setLoading(false);
  }

  handleBulkUpload() {
    const { excelRows } = this.state;
    console.log('handleBulkUpload.excelRows', excelRows);
    const bulkData = excelRows.map((row) => ({
      batchId: row[0],
      supplierCode: row[1],
      erpName: row[2],
      COMPANY_NAME: row[3],
      PROD_CODE: row[4],
      PRODUCT_NAME: row[5],
      UOM: row[6],
      Conversion: row[7],
      OPENING_STOCK: row[8],
      GOODS_RECEIVED: row[9],
      SALES_QTY: row[10],
      CLOSING_STOCK: row[11],
      isConversionFound: row[14],
      uniquekey: row[15]
    }));

    AppActions.setLoading(true);
    ConversionDataService.bulkCreate({ bulkData }).then((response) => {
      AppActions.setLoading(false);
     
      if (response.data.success) {
        var notify_message = {
          type: "success",
          message: "Bulk Conversions uploaded successfully.",
        };
        this.notify(notify_message.type, notify_message.message);
      } else {
        var notify_message = {
          type: "error",
          message: response.data.message,
        };
        this.notify(notify_message.type, notify_message.message);
      }
    });
  }

  skipAndProcess = async(batchId, batch) => {
    console.log('skipAndProcess.batchId', batchId);
    console.log('skipAndProcess.batch', batch);

    ProcessFileService.skipAndProcess(batchId).then((response) => {
    });

    // await processFileById(id, batch.supplierCode);
  }

  notify(type, message) {
		toast(message, {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			type: type,
		});
	}

  downloadIncrementalFile(id) {
    incrementalService.getIncrementalRecords(id).then((response) => {
      if (response.data && response.data.length > 0) {
        if(response.data[0].length){
          const incCustomerCodesArray = JSON.parse(JSON.stringify(response.data[0]));
          const sheetdata = [];
          sheetdata.push(["BatchId", "SupplierCode", "DSCode", "CustCode", "CustName", "Street", "District", "City"]);
          incCustomerCodesArray.forEach((itm) => {
            sheetdata.push([itm.batchId, itm.supplierCode, itm.DSCODE.trim(), itm.CUSTCODE, '', '', '', '']);
          });
          var fileName = incCustomerCodesArray[0].supplierCode + "CM_" + id;
          this.prepWorkbookFromJson(sheetdata, fileName);
        }
        if(response.data[1].length){
          const incProductCodesArray = JSON.parse(JSON.stringify(response.data[1]));
          const sheetdata = [];
          sheetdata.push(["BatchId", "SupplierCode", "DSCode", "ProductCode", "ProductDesc", "Company", "Price"]);
          incProductCodesArray.forEach((itm) => {
            sheetdata.push([itm.batchId, itm.supplierCode, itm.DSCODE.trim(), itm.PRODCODE, '', '', '']);
          });
          var fileName = incProductCodesArray[0].supplierCode + "PM_" + id;
          this.prepWorkbookFromJson(sheetdata, fileName);
        }
        if(response.data[2].length){
          const incBranchCodesArray = JSON.parse(JSON.stringify(response.data[2]));
          const sheetdata = [];
          sheetdata.push(["CICC", "CHAIN_CODE", "BRANCH_CODE", "BRANCH_NAME", "CITY", "DISTRICT", "DISTRICT_A", "ADDRESS","ACTIVE","NEW_BRICK","MASTER_BRICK_6","BRICK_30_CODE","BRICK_30_NAME","BRICK_28_CODE","BRICK_28_NAME","REGION"]);
          incBranchCodesArray.forEach((itm) => {
            sheetdata.push([itm.CICC, itm.DSCODE.trim(), itm.BRANCHCODE, '', '', '', '', '', 'true',0,0,0,'',itm.BRICK_28_CODE, itm.BRICK_28_NAME, itm.REGION ]);
          });
          var fileName = incBranchCodesArray[0].supplierCode + "BM_" + id;
          this.prepWorkbookFromJson(sheetdata, fileName);
        }
      }
    });
    /*if (item.statustxt.indexOf("Product Description is empty") > -1) {
      incrementalService.getIncrementalRecords("product", id).then((response) => {
        if (response.data && response.data.length > 0) {
          const incrementalRecordsArray = JSON.parse(JSON.stringify(response.data));
          const sheetdata = [];
          sheetdata.push(["BatchId", "SupplierCode", "DSCode", "ProductCode", "ProductDesc", "Company", "Price"]);
          incrementalRecordsArray.forEach((itm) => {
            sheetdata.push([itm.batchId, itm.supplierCode, itm.DSCODE.trim(), itm.PRODCODE, '', '', '']);
          });
          var fileName = item.supplierCode + "PM_" + id;
          this.prepWorkbookFromJson(sheetdata, fileName);
        }
      });
    }
    else if (item.statustxt.indexOf("Customer Name is empty") > -1) {
      incrementalService.getIncrementalRecords("customer", id).then((response) => {
        if (response.data && response.data.length > 0) {
          const incrementalRecordsArray = JSON.parse(JSON.stringify(response.data));
          const sheetdata = [];
          sheetdata.push(["BatchId", "SupplierCode", "DSCode", "CustCode", "CustName", "Street", "District", "City"]);
          incrementalRecordsArray.forEach((itm) => {
            sheetdata.push([itm.batchId, itm.supplierCode, itm.DSCODE.trim(), itm.CUSTCODE, '', '', '', '']);
          });
          var fileName = item.supplierCode + "CM_" + id;
          this.prepWorkbookFromJson(sheetdata, fileName);
        }
      });
    }
    else if (item.statustxt.indexOf("Branch is empty") > -1) {
      incrementalService.getIncrementalRecords("branch", id).then((response) => {
        if (response.data && response.data.length > 0) {
          const incrementalRecordsArray = JSON.parse(JSON.stringify(response.data));
          const sheetdata = [];
          sheetdata.push(["CICC", "CHAIN_CODE", "BRANCH_CODE", "BRANCH_NAME", "CITY", "DISTRICT", "DISTRICT_A", "ADDRESS","ACTIVE","NEW_BRICK","MASTER_BRICK_6","BRICK_30_CODE","BRICK_30_NAME"]);
          incrementalRecordsArray.forEach((itm) => {
            sheetdata.push([itm.CICC, itm.DSCODE.trim(), itm.BRANCHCODE, '', '', '', '', '', 'true',0,0,0,'']);
          });
          var fileName = item.supplierCode + "BM_" + id;
          this.prepWorkbookFromJson(sheetdata, fileName);
        }
      });
    }
    else {
      var notify_message = {
        type: "error",
        message: "No data found",
      };
      this.notify(notify_message.type, notify_message.message);
    }*/
  }

  uploadIncrementalFile() {
    this.setState({ uploadIncrementalRecords: true });
  }

  handleClick = () => {
    this.fileInputRef.current.value = null;
  };

  handleFileChanged(evt){
    AppActions.setLoading(true);
    this.setState({ displayError: false });
    const { target } = evt;
    let file = null;

    if (target.files && target.files.length) {
      file = target.files[0];
      this.readUploadFileData(file);
      if (file.name.indexOf('CM') > -1) {
        this.setState({ uploadedFileType: 'customer' })
      }
      else if (file.name.indexOf('PM') > -1) {
        this.setState({ uploadedFileType: 'product' })
      }
      else if (file.name.indexOf('BM') > -1) {
        this.setState({ uploadedFileType: 'branch' })
      }      
    }        
  }

  async readUploadFileData(file) {
    const reader = new FileReader();
    if (reader.readAsBinaryString) {
      reader.onload = async (e) => {
        this.extractUploadedFileData(reader.result);
      };
      reader.readAsBinaryString(file);
    }
  }

  extractUploadedFileData(data) {
    const workbook = XLSX.read(data, {
      type: "binary",
    });
    const sheet01 = workbook.Sheets[workbook.SheetNames[0]];
    const sheetdata = XLSX.utils.sheet_to_json(sheet01, {
      header: 1,
      blankrows: false
    });
    console.log('extractUploadedFileData.sheetdata', sheetdata);
    sheetdata.splice(0, 1);
    if (sheetdata.length && sheetdata[0].length)
      this.setState({
        uploadedFileData: sheetdata,
        uploadIncrementalFile: true,
      });
    else this.notify("error", "No data found in the sheet");
    AppActions.setLoading(false);
  }

  handleIncrementalData() {
    const { uploadedFileData, uploadedFileType } = this.state;
    console.log(uploadedFileData);
    let bulkData = null;
    if (uploadedFileType === 'customer') {
      bulkData = uploadedFileData.map((row) => ({
        batchId: row[0],
        supplierCode: row[1],
        DSCode: row[2],
        CustCode: row[3] ? row[3].toString().trim() : '',
        CustName: row[4],
        Street: row[5],
        District: row[6],
        City: row[7]
      }));
    }
    else if (uploadedFileType === 'product') {
      bulkData = uploadedFileData.map((row) => ({
        batchId: row[0],
        supplierCode: row[1],
        DSCode: row[2],
        ProductCode: row[3] ? row[3].toString().trim() : '',
        ProductDesc: row[4],
        Company: row[5],
        Price: row[6]
      }));
    }
    else if (uploadedFileType === 'branch') {
      bulkData = uploadedFileData.map((row) => ({
        CICC: row[0] ? row[0].toString().trim() : '',
        CHAIN_CODE: row[1],
        BRANCH_CODE: row[2] ? row[2].toString().trim() : '',
        BRANCH_NAME: row[3] ? row[3].toString().trim() : '',
        CITY: row[4] ? row[4].toString().trim() : '',
        DISTRICT: row[5] ? row[5].toString().trim() : '',
        DISTRICT_A: row[6],
        ADDRESS: row[7],
        ACTIVE: row[8],
        NEW_BRICK: row[9],
        MASTER_BRICK_6: row[10],
        BRICK_30_CODE: row[11],
        BRICK_30_NAME: row[12] ? row[12].toString().trim() : '',
        BRICK_28_CODE: row[13] ? row[13].toString().trim() : '',
        BRICK_28_NAME: row[14] ? row[14].toString().trim() : '',
        REGION: row[15] ? row[15].toString().trim() : '',
      }));
    }
    console.log('handleIncrementalData.bulkData', bulkData);
    if (bulkData && bulkData.length > 0) {
      AppActions.setLoading(true);
      if (uploadedFileType === 'branch') {
        const hasEmptyValue = bulkData.some(item => item.CICC === '' ||
          item.CHAIN_CODE === '' ||
          item.BRANCH_CODE === '' ||
          item.BRANCH_NAME === '' ||
          item.CITY === '' ||
          item.DISTRICT === '' ||
          item.ACTIVE === undefined ||
          item.NEW_BRICK === undefined ||
          item.MASTER_BRICK_6 === undefined ||
          item.BRICK_30_CODE === undefined ||
          item.BRICK_30_NAME === '');
        if (hasEmptyValue) {
          this.setState({ displayError: true });
          AppActions.setLoading(false);
          return;
        }
        else {
          const isValid = bulkData.some(item => isNaN(item.NEW_BRICK) || 
            isNaN(item.MASTER_BRICK_6) || isNaN(item.BRICK_30_CODE)
          );
          if(isValid){
            AppActions.setLoading(false);
            this.notify('error', 'Please enter valid numbers for NEW_BRICK, MASTER_BRICK_6 and BRICK_30_CODE.');
            return;
          }
        }
      }
      incrementalService.insertData(uploadedFileType, bulkData).then((response) => {
        AppActions.setLoading(false);
        if (response.data.success) {
          var notify_message = {
            type: "success",
            message: "Incremental data uploaded successfully.",
          };
          this.notify(notify_message.type, notify_message.message);
        } else {
          var notify_message = {
            type: "error",
            message: response.data.message,
          };
          this.notify(notify_message.type, notify_message.message);
        }
      });
    }
    else {
      var notify_message = {
        type: "error",
        message: "No data sent for bulk upload.",
      };
      this.notify(notify_message.type, notify_message.message);
    }
  }
  // async exportConversionsToExcel(batchId, item) {
  //   console.log('exportConversionsToExcel.batchId', batchId);

  //   ProcessFileService.getConversionList(batchId)
  //     .then((response) => {
  //       const conversionList = response.data.output;
  //       console.log('exportConversionsToExcel.conversionList', conversionList);
  //       const sheetdata = [];
  //       sheetdata.push(["Pack Size", "Conversion Factor", "batchId"]);
  //       for (let i = 0; i < conversionList.length; i++) {
  //         const conItem = conversionList[i];
  //         sheetdata.push([conItem.actualBaseValue, conItem.convertedValue, batchId]);
  //       }
  //       this.prepWorkbookFromJson(sheetdata, item);
  //     })
  //     .catch((error) => {
  //       console.log('exportConversionsToExcel.error', error);
  //     });

  // }

  // prepWorkbookFromJson(sheetdata, item) {
  //   const worksheet = XLSX.utils.json_to_sheet(sheetdata, {
  //     skipHeader: true,
  //   });
  //   const wsColWidths = sheetdata[0].map((th) => ({ wch: th.length + 1 }));
  //   worksheet["!cols"] = wsColWidths;
  //   const workbook = {
  //     Sheets: { ["Sheet1"]: worksheet },
  //     SheetNames: ["Sheet1"],
  //   };
  //   const excelBuffer = XLSX.write(workbook, {
  //     type: "buffer",
  //     bookType: "xlsx",
  //   });
  //   this.createUrlFromBlob(excelBuffer, item);
  // }

  // createUrlFromBlob(bufferData, item) {
  //   //console.log('item', item);
  //   const blob = new Blob([bufferData], { type: EXCEL_TYPE });
  //   const objurl = URL.createObjectURL(blob);

  //   let fileName = "CF_" + new Date().getTime() + EXCEL_EXTENSION;
  //   if(item){
  //     fileName = `CF_${item.supplierCode}_${item.year}_${item.month}`;
  //   }

  //   this.downloadConversionFile(objurl, fileName);
  //   //this.downloadConversionFile(objurl, "conversion_factor_master_" + new Date().getTime() + EXCEL_EXTENSION);
  //   URL.revokeObjectURL(objurl);
  // }

  // downloadConversionFile(objurl, filename) {
  //   const anchor = document.createElement("a");
  //   anchor.href = objurl;
  //   anchor.download = filename;
  //   document.body.appendChild(anchor);
  //   anchor.click();
  //   document.body.removeChild(anchor);
  // }  

  render() {
    const {
      selectedTab,
      filteredBReport,
      downloadedReport,
      validationReport,
      processReport,
      completeReport,
      conversionReport,
      conversionCompleteReport,
      failedReport,
      pendingReport,
      uploadedReport,
      cancelledReport,
      selectedBatch,
      batchLogs,
      dateFrom,
      dateTo,
      supplierList,
      selectedSupplier,
      monthList,
      yearList,
      selectedMonth,
      selectedYear,
      projectList,
      selectedProject,
      fullscreen,
      showModal,
      showModalProcessed,
      supplierNameTxt,
      supplierCodeTxt,
      sortedColumn,
      filteredColumn,
      filteredColumnValue,
      batchIdArray,
      sortType,
      processFileByIdQueue,
      uploadReady,
      uploadIncrementalRecords,
      displayError
    } = this.state;


    return (
      <>
        
        <Row className="mb-4">
          <Col md="12" className="mt-3">
              <h6 className="m-0">Batch Report</h6>
          </Col>
          <Col md="12" className="">
            <Row>
              {INDIA && ( 
                <>
                <Col md="3" className="flx-dir-col">
                  <label className="mb-0">Select {SPAIN ? 'Hospital' : 'Supplier'}</label>
                  <FormSelect
                    id="supplier-select"
                    onChange={this.handleSelectedSupplierChange}
                    value={selectedSupplier}
                  >
                    <option value={0}>Select</option>
                    {supplierList.map((supplier, index) => (
                      <option key={supplier.supplierCode+index} value={supplier.supplierCode}>
                        {supplier.supplierCode}-{supplier.supplierName}
                      </option>
                    ))}
                  </FormSelect>
                </Col>
              
              <Col md="2" className="flx-dir-col">
                <label className="mb-0">Select Year</label>
                <FormSelect
                  id="year-select"
                  onChange={(evt) =>
                    this.setState({
                      selectedYear: evt.target.value,
                    })
                  }
                  value={selectedYear}
                >
                  <option value={0}>Select</option>
                  {yearList.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </FormSelect>
              </Col>
              <Col md="2" className="flx-dir-col">
                <label className="mb-0">Select Month</label>
                <FormSelect
                  id="month-select"
                  onChange={(evt) =>
                    this.setState({
                      selectedMonth: evt.target.value,
                    })
                  }
                  value={selectedMonth}
                >
                  <option value={0}>Select</option>
                  {monthList.map((mnth) => (
                    <option key={mnth} value={mnth}>
                      {mnth}
                    </option>
                  ))}
                </FormSelect>
              </Col>
              <Col md="auto" className="d-flex">
                <button
                  className="btn btn-primary mt-auto"
                  disabled={!selectedMonth}
                  onClick={this.downloadFile}
                >
                  Download File
                </button>
              </Col>
              </>
              )}
              {INDIA && (
                <Col md="auto" className="d-flex">
                  <button
                    className="btn btn-primary mt-auto"
                    disabled={!selectedMonth}
                    onClick={this.processFile}
                  >
                    Process File
                  </button>
                </Col>
              )}
              {INDIA && (
                <Col md="auto" className="d-flex">
                  <button
                    className="btn btn-primary mt-auto"
                    disabled={!selectedMonth}
                    onClick={this.uploadFiles}
                  >
                    Upload File
                  </button>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
        
        {uploadReady && (
          <Row>
            <Col md="12" className="mb-0" >
              <Form>
                <Row form>
                  <Col className="form-group">
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="">Upload Conversion File</label>
                      </Col>
                      <Col className="form-field" md="4">
                        <div className="file-ctrl-wrap">
                          <input
                            type="file"
                            className="file-input"
                            id="file"
                            name="file"
                            placeholder="Browse excel file to upload"
                            onChange={this.onFileChanged}
                          />
                        </div>
                      </Col>
                    
                    {uploadReady ? (
                      
                        <Col className="form-button" md="4">
                          <Button variant="primary" className="ml-3 btn btn-success" onClick={this.handleBulkUpload}>
                            <FcPlus /> Upload Conversion Data
                          </Button>
                        </Col>
                      
                    ) : (
                      <></>
                    )}
                    </Row>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        )}
        
        {uploadIncrementalRecords && (
          <Row>
            <Col md="12" className="mb-0" >
              <Form>
                <Row form>
                  <Col className="form-group">
                    <Row className="form-group-row">
                      <Col className="form-label" md="4">
                        <label htmlFor="">Upload Incremental File</label>
                      </Col>
                      <Col className="form-field" md="4">
                        <div className="file-ctrl-wrap">
                          <input
                            type="file"
                            className="file-input"
                            id="uploadIncfile"
                            name="uploadIncfile"
                            ref={this.fileInputRef}
                            placeholder="Browse excel file to upload"
                            onChange={this.handleFileChanged}
                            onClick={this.handleClick}
                          />                                                    
                        </div>
                        {displayError && (
                          <span className="text-danger" style={{ fontSize: 'x-small' }}>Please fill all mandatory columns i.e CICC,CHAIN_CODE,BRANCH_CODE,BRANCH_NAME,CITY,DISTRICT,ACTIVE,NEW_BRICK,MASTER_BRICK_6,BRICK_30_CODE,BRICK_30_NAME</span>
                        )}
                      </Col>
                    
                    {uploadIncrementalRecords ? (
                      
                        <Col className="form-button" md="4">
                          <Button variant="primary" className="ml-3 btn btn-success" onClick={this.handleIncrementalData}>
                            <FcPlus /> Upload Incremental Data
                          </Button>
                        </Col>
                      
                    ) : (
                      <></>
                    )}
                    </Row>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        )}

        <Row>
          <Col>
            <Card small className="mb-4">
              <CardHeader className="row no-gutters removemargin">
                
                <Col md="4" className="mt-3">
                  <Row className="form-group mr-1">
                    {/* <Col className="form-field" md="6">
                      <FormInput
                        id="supplierNameTxt"
                        placeholder="supplier Name"
                        value={supplierNameTxt}
                        onChange={this.onChangeSupplierNameTxt}
                      />
                    </Col>
                    <Col className="form-label text-center" md="1">
                    or
                    </Col> */}
                    <Col className="form-field" md="12">
                    <label className="mb-0">Supplier Code</label>
                      <FormInput
                        id="supplierCodeTxt"
                        placeholder="supplier Code"
                        value={supplierCodeTxt}
                        onChange={this.onChangeSupplierCodeTxt}
                      />
                    </Col>
                  </Row>
                </Col>
                
                <Col md="6" className="mt-3">
                  <Row className="form-group">
                    <Col md="3">
                      <label className="mb-0">From Date</label>
                      <DatePicker
                        selected={dateFrom}
                        onChange={(dt) => this.dateChanged(dt, "dateFrom")}
                        placeholderText="Select"
                        dropdownMode="select"
                        dateFormat="dd/MM/yyyy"
                      />
                    </Col>
                    <Col md="3">
                      <label className="mb-0">To Date</label>
                      <DatePicker
                        selected={dateTo}
                        onChange={(dt) => this.dateChanged(dt, "dateTo")}
                        placeholderText="Select"
                        dropdownMode="select"
                        dateFormat="dd/MM/yyyy"
                      />
                    </Col>
                    <Col md="2" className="d-flex">
                      <button
                        className="btn theme-search mt-auto"
                        onClick={this.fetchBatchByDates}
                        disabled={!dateFrom || !dateTo}
                      >
                        <FiSearch size={16} />
                      </button>
                    </Col>

                    {INDIA && batchIdArray.length > 0 && (
                      <>  
                        <Col md="4" className="d-flex">
                          <button
                            className="btn btn-primary mt-auto"
                            disabled={batchIdArray.length === 0}
                            onClick={this.uploadMultipleFile}
                          >
                            Upload Selected File ({batchIdArray.length})
                          </button>
                        </Col>
                      </>
                    )}

                  {SPAIN && batchIdArray.length > 0 && selectedTab === "complete" && (
                    <>
                      <Col md="4" className="d-flex">
                        <button
                          className="btn btn-primary mt-auto"
                          disabled={batchIdArray.length === 0}
                          onClick={this.exportMultipleFileToCSV}
                        >
                          Export Multiple File ({batchIdArray.length})
                        </button>
                      </Col>
                    </>
                  )}

                    

                  </Row>
                </Col>
              </CardHeader>


              <CardHeader className="row no-gutters removemargin">
                <Col md="12" className="mt-3 removemargin">
                  <Row className="form-group">
                    <Col className="form-field" md="2">
                      <label className="mb-0">Sorting</label>
                      <FormSelect
                        id="column-sort"
                        onChange={(evt) => this.startSorting(evt)}
                        value={sortedColumn}
                      >
                        <option value={0}>Select</option>
                        {Columns.map((column) => (
                          <option key={column.value} value={column.value}>
                            {column.title}
                          </option>
                        ))}
                      </FormSelect>
                    </Col>
                    <Col md="1" className="mt-4">
                      {!sortType ? (
                        <a className="text-warning" href="javascript:void(0)" onClick={this.sortingAlphabet}>
                          <FcAlphabeticalSortingZa size={20} />
                        </a>
                      ) : (
                        <a className="text-warning" href="javascript:void(0)" onClick={this.sortingAlphabet}>
                        <FcAlphabeticalSortingAz size={20} />
                      </a>
                      )}
                      
                     
                    </Col>
                    <Col className="form-field" md="2">
                      <label className="mb-0">Filter</label>
                      <FormSelect
                        id="column-filter"
                        onChange={(evt) => this.setState({ filteredColumn: evt.target.value })}
                        value={filteredColumn}
                      >
                        <option value={0}>Select</option>
                        {Columns.map((column) => (
                          <option key={column.value} value={column.value}>
                            {column.title}
                          </option>
                        ))}
                      </FormSelect>

                    </Col>
                    <Col className="form-field" md="2">
                    <label className="mb-0">Filter Value</label>
                      <FormInput
                        id="column-filter-value"
                        placeholder="Filter Value"
                        value={filteredColumnValue}
                        onChange={this.onChangeFilteredColumnValue}
                      />
                    </Col>
                    <Col md="1" className="mt-4">
                      <a className="text-warning" data-tip data-for="cloneTip" href="javascript:void(0)" onClick={this.fetchBatchReport}>
                       <img src={refresh} className="refresh-icon" width="30px" />
                      </a>
                    </Col>
                    {INDIA && batchIdArray.length > 0 && (
                      <>
                        <Col md="2" className="d-flex">
                          <button
                            className="btn btn-primary mt-auto"
                            disabled={batchIdArray.length === 0}
                            onClick={this.processMultipleFile}
                          >
                            Process Selected File ({batchIdArray.length})
                          </button>
                        </Col>
                        <Col md="2" className="d-flex">
                          <button
                            className="btn btn-primary mt-auto"
                            disabled={batchIdArray.length === 0}
                            onClick={this.downloadMultipleFile}
                          >
                            Download Selected File ({batchIdArray.length})
                          </button>
                        </Col>
                      </>
                    )}
                  </Row>
                </Col>
                
                
              </CardHeader>

              <CardBody className="p-0">
                <Tab.Container
                  id="tab-panel-batch-report"
                  activeKey={selectedTab}
                  onSelect={this.tabSelected}
                >
                  <Row className="mt-3">
                    <Col md={12} className="nav-theme-1">
                      <Nav variant="tabs">
                        <Nav.Item className="clr-thm-all">
                          <Nav.Link eventKey="all">ALL ({filteredBReport.length || 0})</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="clr-thm-downloaded">
                          <Nav.Link eventKey="downloaded">DOWNLOADED ({downloadedReport.length || 0})</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="clr-thm-validation">
                          <Nav.Link eventKey="validation">VALIDATION ({validationReport.length || 0})</Nav.Link>
                        </Nav.Item>
                        {/* <Nav.Item className="clr-thm-process">
                          <Nav.Link eventKey="process">PROCESS</Nav.Link>
                        </Nav.Item> */}
                        <Nav.Item className="clr-thm-complete">
                          <Nav.Link eventKey="complete">PROCESSED ({completeReport.length || 0})</Nav.Link>
                        </Nav.Item>
                        {INDIA && (
                          <Nav.Item className="clr-thm-conversion">
                            <Nav.Link eventKey="conversion">PENDING CONVERSIONS ({conversionReport.length || 0})</Nav.Link>
                          </Nav.Item>
                        )}
                        {INDIA && (
                          <Nav.Item className="clr-thm-conversion_added">
                            <Nav.Link eventKey="conversion_added">COMPLETED CONVERSIONS ({conversionCompleteReport.length || 0})</Nav.Link>
                          </Nav.Item>
                        )}
                        {INDIA && (
                          <Nav.Item className="clr-thm-failed">
                            <Nav.Link eventKey="failed">FAILED ({failedReport.length || 0})</Nav.Link>
                          </Nav.Item>
                        )}
                        {(INDIA || SAUDI || EGYPT) && (
                          <Nav.Item className="clr-thm-uploaded">
                            <Nav.Link eventKey="uploaded">UPLOADED ({uploadedReport.length || 0})</Nav.Link>
                          </Nav.Item>
                        )}
                        <Nav.Item className="clr-thm-pending">
                          <Nav.Link eventKey="pending">PENDING ({pendingReport.length || 0})</Nav.Link>
                        </Nav.Item>
                        {/* <Nav.Item className="clr-thm-cancelled">
                          <Nav.Link eventKey="cancelled">CANCELLED</Nav.Link>
                        </Nav.Item> */}
                      </Nav>
                    </Col>
                    <Col md={12}>
                      <Tab.Content className="tab-theme-1">
                        <Tab.Pane eventKey="all" className="tab-pane-all">
                          <ReportTable
                            ReportData={filteredBReport}
                            selectedReport={selectedBatch}
                            reportSelected={this.batchSelected}
                            processFile={this.processFileById}
                            cancelProcessFile={this.cancelProcessFile}
                            viewRawFile={this.viewRawFileById}
                            viewOriginalFile={this.viewOriginalFileById}
                            processSASFileById={this.processSASFileById}
                            container_classlist={["pt-2"]}
                            tab={"All"}
                            checkboxChecked={this.checkboxChecked}
                            downloadConversionFile={this.downloadConversionFile}
                            uploadConversionFile={this.uploadConversionFile}
                            reDownloadFile={this.reDownloadFile}
                            downloadRawFile={this.downloadRawFile}
                          />
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="downloaded"
                          className="tab-pane-downloaded"
                        >
                          <ReportTable
                            ReportData={downloadedReport}
                            selectedReport={selectedBatch}
                            cancelProcessFile={this.cancelProcessFile}
                            reportSelected={this.batchSelected}
                            processFile={this.processFileById}
                            processSASFileById={this.processSASFileById}
                            container_classlist={["pt-2"]}
                            hasAction={true}
                            tab={"downloaded"}
                            batchIdClicked={this.batchIdClicked}
                            checkboxChecked={this.checkboxChecked}
                            deleteFileById={this.deleteFileById}
                            processFileByIdQueue={processFileByIdQueueArray}
                            downloadConversionFile={this.downloadConversionFile}
                            uploadConversionFile={this.uploadConversionFile}
                            addToQueue={this.addToQueue}
                            reDownloadFile={this.reDownloadFile}
                            downloadRawFile={this.downloadRawFile}
                          />
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="validation"
                          className="tab-pane-validation"
                        >
                          <ReportTable
                            ReportData={validationReport}
                            selectedReport={selectedBatch}
                            reportSelected={this.batchSelected}
                            cancelProcessFile={this.cancelProcessFile}
                            processFile={this.processFileById}
                            viewRawFile={this.viewRawFileById}
                            viewOriginalFile={this.viewOriginalFileById}
                            processSASFileById={this.processSASFileById}
                            container_classlist={["pt-2"]}
                            hasAction={true}
                            tab={"validation"}
                            checkboxChecked={this.checkboxChecked}
                            //downloadConversionFile={this.exportConversionsToExcel}
                            deleteFileById={this.deleteFileById}
                            processFileByIdQueue={processFileByIdQueueArray}
                            downloadConversionFile={this.downloadConversionFile}
                            uploadConversionFile={this.uploadConversionFile}
                            addToQueue={this.addToQueue}
                            skipAndProcess={this.skipAndProcess}
                            reDownloadFile={this.reDownloadFile}
                            downloadRawFile={this.downloadRawFile}
                            downloadIncrementalFile={this.downloadIncrementalFile}
                            uploadIncrementalFile={this.uploadIncrementalFile}
                            downloadErrorFile={this.downloadErrorFile}
                          />
                        </Tab.Pane>
                        {/* <Tab.Pane
                          eventKey="process"
                          className="tab-pane-process"
                        >
                          <ReportTable
                            ReportData={processReport}
                            selectedReport={selectedBatch}
                            reportSelected={this.batchSelected}
                            processFile={this.processFileById}
                            viewRawFile={this.viewRawFileById}
                            viewOriginalFile={this.viewOriginalFileById}
                            container_classlist={["pt-2"]}
                            hasAction={true}
                            tab={"process"}
                          />
                        </Tab.Pane> */}
                        <Tab.Pane
                          eventKey="complete"
                          className="tab-pane-complete"
                        >
                          <ReportTable
                            ReportData={completeReport}
                            selectedReport={selectedBatch}
                            processFile={this.processFileById}
                            reportSelected={this.batchSelected}
                            viewRawFile={this.viewRawFileById}
                            viewOriginalFile={this.viewOriginalFileById}
                            cancelProcessFile={this.cancelProcessFile}
                            uploadFileById={this.uploadFileById}
                            processSASFileById={this.processSASFileById}
                            container_classlist={["pt-2"]}
                            hasAction={true}
                            tab={"complete"}
                            checkboxChecked={this.checkboxChecked}
                            processFileByIdQueue={processFileByIdQueueArray}
                            downloadConversionFile={this.downloadConversionFile}
                            uploadConversionFile={this.uploadConversionFile}
                            addToQueue={this.addToQueue}
                            reDownloadFile={this.reDownloadFile}
                            downloadFileById={this.downloadFileById}
                            downloadRawFile={this.downloadRawFile}
                            uploadFileToDB={this.uploadFileToDB}
                          />
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="conversion"
                          className="tab-pane-conversion"
                        >
                          <ReportTable
                            ReportData={conversionReport}
                            selectedReport={selectedBatch}
                            processFile={this.processFileById}
                            reportSelected={this.batchSelected}
                            viewRawFile={this.viewRawFileById}
                            viewOriginalFile={this.viewOriginalFileById}
                            cancelProcessFile={this.cancelProcessFile}
                            uploadFileById={this.uploadFileById}
                            processSASFileById={this.processSASFileById}
                            container_classlist={["pt-2"]}
                            hasAction={true}
                            tab={"conversion"}
                            checkboxChecked={this.checkboxChecked}
                            processFileByIdQueue={processFileByIdQueueArray}
                            downloadConversionFile={this.downloadConversionFile}
                            uploadConversionFile={this.uploadConversionFile}
                            goToReport={this.goToReport}
                            reDownloadFile={this.reDownloadFile}
                            downloadRawFile={this.downloadRawFile}
                          />
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="conversion_added"
                          className="tab-pane-conversion_added"
                        >
                          <ReportTable
                            ReportData={conversionCompleteReport}
                            selectedReport={selectedBatch}
                            processFile={this.processFileById}
                            reportSelected={this.batchSelected}
                            viewRawFile={this.viewRawFileById}
                            viewOriginalFile={this.viewOriginalFileById}
                            cancelProcessFile={this.cancelProcessFile}
                            uploadFileById={this.uploadFileById}
                            processSASFileById={this.processSASFileById}
                            container_classlist={["pt-2"]}
                            hasAction={true}
                            tab={"conversion_added"}
                            checkboxChecked={this.checkboxChecked}
                            processFileByIdQueue={processFileByIdQueueArray}
                            downloadConversionFile={this.downloadConversionFile}
                            uploadConversionFile={this.uploadConversionFile}
                            reDownloadFile={this.reDownloadFile}
                            downloadRawFile={this.downloadRawFile}
                          />
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="failed"
                          className="tab-pane-failed"
                        >
                          <ReportTable
                            ReportData={failedReport}
                            selectedReport={selectedBatch}
                            reportSelected={this.batchSelected}
                            processFile={this.processFileById}
                            viewRawFile={this.viewRawFileById}
                            viewOriginalFile={this.viewOriginalFileById}
                            cancelProcessFile={this.cancelProcessFile}
                            uploadFileById={this.uploadFileById}
                            processSASFileById={this.processSASFileById}
                            container_classlist={["pt-2"]}
                            hasAction={true}
                            tab={"failed"}
                            checkboxChecked={this.checkboxChecked}
                            downloadConversionFile={this.downloadConversionFile}
                            uploadConversionFile={this.uploadConversionFile}
                            reDownloadFile={this.reDownloadFile}
                            downloadRawFile={this.downloadRawFile}
                          />
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="uploaded"
                          className="tab-pane-uploaded"
                        >
                          <ReportTable
                            ReportData={uploadedReport}
                            selectedReport={selectedBatch}
                            reportSelected={this.batchSelected}
                            processFile={this.processFileById}
                            viewRawFile={this.viewRawFileById}
                            viewOriginalFile={this.viewOriginalFileById}
                            uploadFileById={this.uploadFileById}
                            processSASFileById={this.processSASFileById}
                            container_classlist={["pt-2"]}
                            hasAction={true}
                            tab={"uploaded"}
                            checkboxChecked={this.checkboxChecked}
                            downloadConversionFile={this.downloadConversionFile}
                            uploadConversionFile={this.uploadConversionFile}
                            reDownloadFile={this.reDownloadFile}
                            downloadRawFile={this.downloadRawFile}
                          />
                        </Tab.Pane>
                        <Tab.Pane
                          eventKey="pending"
                          className="tab-pane-pending"
                        >
                          <ReportTable
                            ReportData={pendingReport}
                            selectedReport={selectedBatch}
                            reportSelected={this.batchSelected}
                            processFile={this.processFileById}
                            viewRawFile={this.viewRawFileById}
                            viewOriginalFile={this.viewOriginalFileById}
                            cancelProcessFile={this.cancelProcessFile}
                            uploadFileById={this.uploadFileById}
                            processSASFileById={this.processSASFileById}
                            container_classlist={["pt-2"]}
                            hasAction={true}
                            tab={"failed"}
                            checkboxChecked={this.checkboxChecked}
                            processFileByIdQueue={processFileByIdQueueArray}
                            downloadConversionFile={this.downloadConversionFile}
                            uploadConversionFile={this.uploadConversionFile}
                            reDownloadFile={this.reDownloadFile}
                            downloadRawFile={this.downloadRawFile}
                          />
                        </Tab.Pane>
                        {/* <Tab.Pane
                          eventKey="cancelled"
                          className="tab-pane-cancelled"
                        >
                          <ReportTable
                            ReportData={cancelledReport}
                            selectedReport={selectedBatch}
                            reportSelected={this.batchSelected}
                            processFile={this.processFileById}
                            viewRawFile={this.viewRawFileById}
                            viewOriginalFile={this.viewOriginalFileById}
                            container_classlist={["pt-2"]}
                            hasAction={true}
                            tab={"cancelled"}
                          />
                        </Tab.Pane> */}
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal show={showModal} fullscreen={fullscreen} onHide={this.hideModal}>
          <Modal.Header>
            <Modal.Title>Original File</Modal.Title>
            <div
              className="closeBtn"
              onClick={this.hideModal}
              aria-label="Close"
            >
              <TiDeleteOutline />
            </div>
          </Modal.Header>
          <Modal.Body>
            {this.state.originalData && this.state.originalData > 0 && (
                <>
              <Container>
                      <Row>
                          <TableColumnRow
                              rows={this.state.originalData}
                              headers={this.state.originalData[0]}
                              // clearData={clearData}
                          />
                      </Row>
                  </Container>
                
                <Container>
                    <Row>
                        <TableRow
                            rows={this.state.originalData}
                            // clearData={clearData}
                        />
                    </Row>
                </Container>
                </>
                )
            }
          </Modal.Body>
        </Modal>

        <Modal show={showModalProcessed} fullscreen={fullscreen} onHide={this.hideModalProcessed}>
          <Modal.Header>
            <Modal.Title>Original File</Modal.Title>
            <div
              className="closeBtn"
              onClick={this.hideModalProcessed}
              aria-label="Close"
            >
              <TiDeleteOutline />
            </div>
          </Modal.Header>
          <Modal.Body>
          <ScaleLoader
                cssOverride={override}
                size={40}
                color={"#1484cd"}
                loading={this.state.loading}
                speedMultiplier={1.5}
              />
          {this.state.rows && this.state.rows.length > 0 && (
              <>
            <Container>
                    <Row>
                        <TableColumnRow
                            rows={this.state.columnsRows}
                            headers={this.state.headers}
                            // clearData={clearData}
                        />
                    </Row>
                </Container>
              
              <Container>
                  <Row>
                      <TableRow
                          rows={this.state.rows}
                          // clearData={clearData}
                      />
                  </Row>
              </Container>
              </>
              )
           }
          </Modal.Body>
        </Modal>

        {selectedBatch._id ? (
          <ProcessLogs batchCode={selectedBatch._id} processLogs={batchLogs} />
        ) : (
          <></>
        )}
      </>
    );
  }
}

export default ViewBatchReport;
